import React from "react";
import AccordionCustoms from "./Accordion_custom";
import AccordionSummarys from "./Accordion_summary";
import { ExpandMore as ExpandMoreIcon } from "components/icon/mui_icon";
import {
  AccordionDetails,
  Chip,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import { isValidValue } from "utils";
import { POCFormGrid } from "customStyled";
import { useTranslation } from "react-i18next";

const MuiChip = styled(Chip)(({ theme }) => ({
  background: "#F2F4F7",
  color: "#344054",
}));
const MuiChipActive = styled(Chip)(({ theme }) => ({
  background: "#ECFDF3",
  color: "#027A48",
}));
const MuiChipError = styled(Chip)(({ theme }) => ({
  background: "#FEF3F2",
  color: "#B42318",
}));

const Accordion = ({
  id,
  title,
  value = {},
  required = true,
  children,
  valid = false,
  touched = false,
}) => {
  const { t } = useTranslation("form");
  const formKey = [];
  Object.keys(value).forEach((el) => {
    if (
      el !== "countryCode" &&
      el !== "type" &&
      el !== "prefix" &&
      (el === "role" ? value["type"] === "other" : true)
    ) {
      formKey.push(value[el]);
    }
  });
  const formValid = formKey.filter(
    (el) => el === "" || !isValidValue(el)
  ).length;

  return (
    <React.Fragment>
      <AccordionCustoms slotProps={{ heading: { component: "h6" } }}>
        <AccordionSummarys
          expandIcon={<ExpandMoreIcon />}
          aria-controls={id}
          id={id}
        >
          <Stack
            direction={"row"}
            spacing={1.5}
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
              flexGrow: 1
            }}>
            <Typography
              color={!valid && touched ? "#B42318" : "#101828"}
              sx={{ fontWeight: 600 }}
            >
              {title}
              {!required ? (
                <span
                  style={{
                    color: "#70737B",
                    marginLeft: "8px",
                    fontWeight: 400,
                  }}
                >
                  {t("optional")}
                </span>
              ) : null}
            </Typography>
            {true ? (
              valid && formValid === 0 ? (
                <MuiChipActive label={t("completed")} />
              ) : touched && !valid ? (
                <MuiChipError label={t("notCompleted")} />
              ) : (
                <MuiChip label={t("notCompleted")} />
              )
            ) : null}
          </Stack>
        </AccordionSummarys>
        <AccordionDetails>
          <POCFormGrid container spacing={2}>
            {children}
          </POCFormGrid>
        </AccordionDetails>
      </AccordionCustoms>
    </React.Fragment>
  );
};

export default Accordion;
